export default {
  coffeeData: {
    windBreaker: "Árbol cortavientos",
    horticultureInfo: "Árbol en la horticultura",
    shadeTree: "Árbol de sombra",
    coffeeVariety: "Variedad de café",
    coffeeSpecies: "Especies de café",
    updateWindBreaker: "Actualizar el tipo de árbol cortavientos",
    addWindBreaker: "Añadir nuevo tipo de árbol rompevientos",
    updateHorticultureInfo:
      "Actualizar la información del tipo de árbol en la horticultura",
    addHorticultureInfo:
      "Añadir nueva información del tipo de árbol en la horticultura",
    updateShadeTree: "Actualizar el tipo de árbol cortavientos",
    addShadeTree: "Add New shadeTree Tree Type",
    updateCoffeeVariety: "Actualizar el tipo de la variedad de café",
    addCoffeeVariety: "Añadir el nuevo tipo de árbol de la variedad de café",
    deleteVarietyTitle: "Eliminar la variedad",
    deleteVarietyMessage: "¿Seguro que desea eliminar esta variedad?",
    updateCoffeeSpecie: "Actualizar la especie de café",
    deleteSpecieTitle: "Eliminar la especie",
    deleteSpecieMessage: "¿Seguro que desea eliminar esta especie?",
    addCoffeeSpecie: "Añadir nueva especie de café",
    variety: "Variedad",
    selectVariety: "Seleccionar la variedad",
    deleteCoffeeRecord: "¿Seguro que desea eliminar el registro?",
    deleteCoffeeData: "Eliminar datos del café",
    topicRequired: "Se requiere el nombre del tema",
    coffeeAddSuccess: "Se ha añadido la especie de café correctamente.",
    treeTypeSuccess: "Se ha añadido el tipo de árbol correctamente.",
    treeTypeUpdateSuccess: "Se ha actualizado el tipo de árbol correctamente.",
    coffeeVarietySuccess: "Se ha añadido la variedad de café correctamente.",
    coffeeSpecieSuccess: "Se ha actualizado la especie de café correctamente.",
    nameRequired: "Se requiere el nombre",
    notFound: "No se ha encontrado los datos del admin café",
  },
  cacaoData: {
    cacao: "Cacao",
    cacaoOverview: "Resumen de Cacao",
    cacaoVariety: "Variedad de Cacao",
    cacaoSpecies: "Especie de Cacao",
    deleteCacaoData: "Eliminar Datos de Cacao",
  },

  memberDataSection: {
    import: "Importar",
    buyingStation: "Estación de Compra",
    societies: "Sociedades",
    affiliates: "Afiliados",
    societyInfo: "Info de Sociedad",
    continue: "Continuar",
    farmerId: "ID del Agricultor",
    farmerName: "Nombre del Agricultor",
    farmerAddress: "Dirección del Agricultor",
    quality: "Calidad",
    quantity: "Cantidad",
    unit: "Unidad",
    price: "Precio",
    save: "Guardar",
    stateIsReq: "Se requiere el estado",
    cityIsReq: "Se requiere la ciudad",
    addressIsReq: "Address is required",
    selectCrop: "Seleccionar Cultivo",
    membershipTypeReq: "Membership type is required",
    extendedReasonReq: "Extend reason is required",
    numberOfDaysReq: "Number of days is required",
    extendedMembershipValidity: "Validez extendida de membresía",
    set: "SET",
    adminRole: "Funciones de administrador",
    typeMsg: "Type your message here",
    profile: "Perfil",
    pleaseChooseAnImageFile: "Por favor, elija un archivo de imagen",
    fileIsTooBigSelectUnder1MB:
      "¡Su archivo es demasiado grande! Seleccione una imagen de menos de 1 MB",
    pleaseTryAgainAfterSometime: "Por favor, inténtelo de nuevo más tarde",
    somethingWentWrong: "Algo salió mal.",
    passwordChangedSuccesFully: "Contraseña cambiada con éxito",
    passwordDoesNotMatch: "Las contraseñas no coinciden",
    copyToCliped: "Copiado al portapapeles",
    profileUpdated: "Datos del perfil actualizados.",
    emailAndMobileCantbeEmpty:
      "El correo electrónico y el móvil no pueden estar vacíos.",
    changePassword: "Cambiar contraseña",
    generateSecurePassword: "Generar contraseña segura",
    restoreDefault: "Restaurar por Defecto",
    customization: "Personalización",
    recordsPerPage: "Registros por Página",
    errors: {
      cannotBeBlank: "Este campo no puede quedar vacío",
      required: "Se requiere este campo",
      somethingWentWrong: "Algo salió mal. Inténtalo de nuevo más tarde.",
    },
    loadingData: "Cargando datos...",
    markAsRead: "Marcar como leído",
    membership: {
      remainingDays: "Número de días restantes",
      type: "Tipo de membresía",
      validity: "Validez de la membresía",
      validityLength: {
        custom: "Personalizado",
        expired: "Expirado",
        oneTo8Months: "1-8 meses",
        lessThan1Month: "Menos de 1 mes",
        moreThan1Month: "Más de 1 año",
        sixTo12Months: "6-12 meses",
      },
    },
    of: "de",
    ok: "Vale",
    statusItems: {
      closed: "Cerrado",
      open: "Abierto",
    },
    orderByItems: {
      all: "Todos",
      dateAscending: "Fecha ascendente",
      dateDescending: "Fecha descendente",
      dueDate: "Fecha límite",
      high: "Alto",
      low: "Bajo",
      medium: "Medio",
    },
    orderBy: "Ordenar por",
    uploadImageVideo: "Cargar imágenes/ videos",
    user: "Usuarios",
    topics: "Temas",
    date: "Fecha",
    addNew: "Añadir nuevo",
    exportAsCsv: "Exportar como CSV",
    noData: "No se ha encontrado ningún dato",
    login: {
      welcomeMsg: "¡Bienvenido! Inicie la sesión",
      info: "Ingrese sus credenciales",
      forgot: "¿Ha olvidado la contraseña?",
      btn: "Iniciar sesión",
      unableToLogin: "No es posible iniciar la sesión",
    },
    forgot: {
      info_l1:
        "Ingrese el correo electrónico asociado a su cuenta. Se enviarán los detalles de la contraseña a su correo electrónico.",
      info_l2:
        "Ingrese su número de móvil asociado con la cuenta. Se enviarán los detalles de su contraseña a su móvil.",
      forgotQ: "¿Ha olvidado su contraseña?",
      loginNow: "Iniciar sesión ahora",
      resetSucc: "Se ha restablecido su contraseña correctamente.",
      resetSucc_l2:
        "Ahora usted puede utilizar su nueva contraseña para iniciar su sesión de su cuenta.",
      entPsw: "Ingrese su nueva contraseña.",
      resetPsw: "Restablecer su contraseña",
      resendOTP: "Reenviar OTP",
      enterCorrectOTP: "Ingrese OTP correcto.",
      enterOTP: "Ingrese OTP recibido en su correo electrónico/ móvil.",
      backToLoginPage: "Volver a la página de inicio de sesión",
    },
    userslist: {
      createNewUser: "Crear un Nuevo Usuario",
      chooseCreateType: "Por favor, elija una de las siguientes opciones:",
      addNewUser: "Agregar Nuevo Usuario",
      editUser: "Editar Usuario",
      addNewAdmin: "Agregar Usuario Administrador",
      userLoading: "Cargando Usuarios... Por favor, espere",
      noUser: "NO HAY USUARIO DISPONIBLE",
      extendVal: "EXTENDER VALIDEZ",
      extendReason: "Motivo de la Extensión",
      extendReasonMsg: "Especifique el motivo de la extensión de la membresía",
      exportAsCSV: "EXPORTAR COMO CSV",
      membershipType: "Tipo de Membresía",
      membershipValidity: "Validez de la Membresía",
      regionState: "Región/Estado",
      cityTown: "Ciudad/Pueblo",
      clearAll: "BORRAR TODO",
      search: "BUSCAR",
      familyTribe: "Ingrese su tribu familiar",
      enterWebsite: "Ingrese al sitio web",
      registrationDate: "Fecha de Registro",
      single: "Soltero",
      multiple: "Múltiple",
      user: "Usuario",
    },
    addEdituser: {
      firstNameRequired: "Se requiere primero nombre",
      firstNameOllyAlpha: "El primero nombre solo puede contener letras",
      firstNameLimit: "El primero nombre debe tener menos de 15 caracteres",
      lastNameRequired: "Se requiere Apellido",
      lastNameOllyAlpha: "El Apellido solo puede contener letras",
      lastNameLimit: "El Apellido debe tener menos de 15 caracteres",
      emailReuired: "Se requiere el correo electrónico",
      emailInvalid: "Formato inválido de correo electrónico.",
      mobileRequired: "Se requiere el número de móvil",
      invalidMobile: "Formato de número de móvil inválido.",
      emailExistAlready: "El usuario ya existe con este correo electrónico.",
      mobileExistAlready: "El usuario ya existe con este número de móvil.",
      pswRequired: "Se requiere la contraseña",
      deptRequired: "Se requiere el departamento",
      roleRequired: "Se requiere la función",
      countryRequired: "Se requiere el código del país",
      userUpdated: "Usuario actualizado",
      userNotUpdated: "Usuario no actualizado",
      activateAct: "Activar cuenta",
      deactivateAct: "Desactivar cuenta",
      userActivated: "Usuario activado",
      userDeactivated: "Usuario desactivado",
      deactivateUser: "Desactivar usuario",
      deactivateMsg: "¿Seguro que desea cambiar estado de usuario?",
      userAdded: "Usuario añadido",
      userNotAdded: "Usuario no añadido",
      validityUpTo: "Validity Up To",
      facilityPicture: "Facility Picture",
      editAppUser: "Editar usuario de la aplicación",
    },
    permissions: {
      savePermissions: "Guardar permisos",
      moduleName: "Nombre del módulo",
      view: "Vista",
      create: "Crear",
      update: "Actualizar",
      delete: "Borrar",
      permissionsUpdated: "Permisos actualizados",
      permissionsNotUpdated: "Permisos no actualizados",
      selectMembership: "Seleccionar membresía",
      noPermMsg:
        "Seleccione el tipo de membresía usando el menú desplegable 'Tipo de membresía' arriba para ver sus permisos",
      selectRoleMsg:
        "Seleccione la función de arriba para enseñar los permisos",
    },
    logs: {
      time: "Tiempo",
      username: "Nombre de usuario",
      role: "Función",
      terminalID: "ID del terminal",
      moduleAccessed: "Módulo accedido",
      typeOfAccess: "Tipo de acceso",
      activityLogDetails: "Detalles del registro de actividades",
      userId: "ID del usuario",
      lastLogin: "Último inicio de sesión",
      geoAccPoint: "Punto de acceso geográfico",
      ipAdd: "Dirección IP ",
      filesAccessed: "Archivos accedidos",
      funAccessed: "Función accedida",
      webUrl: "URL de página web",
      unsuccAtmp: "Intentos de inicio de sesión sin éxito",
      view: "Vista",
      membershipType: "Tipo de membresía",
    },
    profileSetting: {
      profileAuthSettings: "Configuración de autenticación de perfil",
      changeSettings: "Configuraciones de cambios",
      loginLogoutSettings:
        "Configuración de inicio de sesión/ cierre de sesión",
      autoLogout: "Cierre automático de sesión",
      unsuccAtmp: "Intentos de inicio de sesión sin éxito",
      unsuccLoginLock: "Periodo de bloqueo de inicio de sesión sin éxito",
      pswCrisetup: "Configuraciones de los parámetros de la contraseña",
      pswLength: "Longitud de contraseña",
      noOfUniquePsw: "Número de contraseñas únicas requeridas",
      maxPswAge: "Edad máxima de la contraseña",
      AccRangeOfchars: "Rango aceptable de caracteres",
      upperCase: "Mayúscula",
      lowerCase: "Minúscula",
      numbers: "números",
      specialChars: "Caracteres especiales",
      settingsUpdated: "Configuraciones actualizadas",
      settingsNotUpdated: "Configuraciones no actualizadas",
      organization: "Organization",
      organizationLogo: "Organization Logo",
      organizationSplash: "Pantalla de presentación de la organización",
    },
    dashboardSection: {
      greenBeansData: "Gestión de Granos Verdes",
      dryMilling: "Molienda en Seco",
      modules: "Módulos",
      allowances: "Subsidios",
      maxUserAllowed: "Máximo de usuarios con permiso",
      satelliteReportsAllowed: "Informes por satélite permitidos ",
      advanceReport: "Informes avanzados permitidos",
      subscriptionUpTo: "Suscripción hasta",
      roleAllowed: "Puestos con permiso ",
      moduleAllowed: "Módulos permitidos ",
      registeredUsers: "Usuarios registrados",
      validMemberships: "Membresía válida",
      activeUsers: "Usuarios activos",
      deactivatedUsers: "Usuarios desactivados",
      membershipValidity: "Validez de la membresía",
      lessThan1Month: "Menos de 1 mes",
      months1to6: "1-6 meses",
      months6to12: "6-12 meses",
      moreThan1Year: "Menos de 1 mes ",
      cropOverview: "Visión general del cultivo",
      plantations: "Plantaciones ",
      coffeeData: "Datos del café",
      availableModules: "Módulos disponibles",
      roleList: "Granjero, central de compras, almacén",
      memberData: "Datos de Miembro",
      userType: "Tipo de Usuario",
      registered: "Registrado",
      offlineUsers: "Usuarios Desconectados",
      lessThanOneMonth: "< 1 Mes",
      cacaoData: "Datos de Cacao",
      dryCacao: "Cacao Seco",
      traceability: "Trazabilidad",
    },
    adminRoles: {
      adminRoles: "Funciones de administrador",
      roleName: "Nombre de la función",
      description: "Descripción",
      viewPermissions: "Visualizar permisos",
      createAdminRole: "CREAR FUNCIÓN DE ADMINISTRADOR",
      enterDesHere: "Ingresar su descripción aquí",
      deleteRole: "Eliminar puesto",
      deleteMsg: "¿Seguro que desea eliminar el puesto de supervisor?",
      roleReq: "Se requiere el nombre de la función",
      roleLimit: "El nombre de la función debe tener menos de 15 caracteres",
      desReq: "Se requiere la descripción",
      desLimit: "La descripción debe tener 40 caracteres o menos",
      roleSuccess: "Se ha creado la función correctamente",
      editAdminRole: "Editar función admin",
      roleUpdated: "usuario actualizado",
      noRole: "No se ha encontrado ninguna función de admin",
      noRoleMsg:
        "Cree la función admin utilizando el botón ' Crear Función Admin' de arriba",
    },
    membershipplanSection: {
      defaultPlan: " Plan por defecto",
      planType: "Tipo de plan",
      planDuration: "Duración del plan",
      planFee: "Tasa del plan",
      satelliteReport: "Informes por satélite",
      advanceReport: "INFORME AVANZADO",
      addMembership: "Añadir membresía",
      addMembershipPlan: "Añadir plan de membresía",
      accessSetelite:
        "Acceso a los informes por satélite (conjunto de 5 informes)",
      accessAdvanceReport: "Acceso a los informes avanzados",
      memPlanReq: "Se requiere el plan de membresía",
      memPlanReqLimit: "El plan de membresía debe tener menos de 20 caracteres",
      SatelliteReq: "Se requiere el informe por satélite",
      advancedReportReq: "Se requiere el informe avanzado",
      durationReq: "Se requiere la duración de la membresía",
      feeReq: "Se requiere la tarifa de membresía",
      cantLesThenZero: "No puede ser menos de 0",
      roleReq: "Se requiere la función del usuario",
    },
    tickets: {
      actions: {
        create: "Crear ticket",
        delete: "eliminar ticket",
        edit: "editar ticket",
      },
      areaOfRequest: "Área de solicitud",
      assignee: "Asignatario",
      deleteTicket: {
        confirmation: "¿Seguro que desea eliminar el ticket?",
      },
      dueDate: "Fecha límite",
      filters: {
        ticketFor: "ticket para",
      },
      form: {
        ticketType: {
          admin: "Crear ticket para Admin Dimitra",
          user: "Crear ticket para el usuario de la aplicación",
        },
      },
      markAsRead: "Marcar como leído",
      messages: {
        created: {
          success: "Se ha creado el ticket correctamente",
        },
        deleted: {
          success: "Se ha eliminado el ticket correctamente",
        },
      },
      noData: "¡No se ha encontrado ningún ticket!",
      noDataHelpText: `Usted no tiene ningún ticket asignado. Haga clic en el botón " Crear Ticket" en la parte superior de esta pantalla para empezar.`,
      pickerInMenu: "Selector en el menú",
      priority: {
        high: "Alto",
        label: "Prioridad",
      },
      reply: "Contestar",
      requestedDateTime: "Fecha y hora solicitadas",
      requestorDetails: "Detalles del solicitante",
      requestorEmail: "Correo electrónico solicitante",
      subject: "tema",
      ticketsForItems: {
        all: "Todos",
        dimitraAdmin: "Admin Dimitra",
        multipleUsers: "Usuarios múltiples",
        singleUser: "Usuario único",
      },
      title: "Tickets",
    },
    roleRequest: {
      roleRequest: "Solicitud de función",
      userRole: "Puesto del usuario",
      approve: "Aprobado",
      reject: "Rechazado",
      username: "Nombre de usuario",
      email: "Correo eletrónico",
      phone: "Teléfono",
      roleAssigned: "Puesto asignado",
      roleRequested: "Puesto solicitado",
      requestedDate: "Fecha solicitada",
      updateRoleRequest: "Actualizar Solicitud de función",
      message: "mensaje",
      update: "Actualizar",
    },
    faqSection: {
      createFaq: "CREAR PREGUNTA FRECUENTE",
      createTopic: "Crear tema",
      selectTopic: "Seleccionar tema",
      faqQuestion: "Pregunta más frecuente",
      faqAnswer: "Respuesta de la pregunta frecuente",
      uploadImgVid: "Cargar imagen/ video",
      disInFaq: "Enseñar en la sección de preguntas frecuentes",
      editFaq: "Editar preguntas frecuentes",
      topicName: "Nombre del tema",
      parentTopic: "Tema principal",
      editTopic: "Editar tema",
      createSection: "Please create section first",
      createTopicFirst: "Please create topic first",
      questionReq: "FAQ Question is required",
      answerReq: "FAQ Answer is required",
    },
    reports: {
      farmerName: "Nombre del granjero",
      farmerProdChart: "Gráfico de producción del granjero",
      production: "Producción",
      byProduction: "Por producción",
      byName: "Por nombre",
      descending: "Descendiente",
      ascending: "Ascendiente",
      buyingStationProdChart: "Gráfico de producción de la central de compra",
      buyingStation: "Central de Compra",
      buyingStationName: "Nombre de la central de compra",
      dryMilling: "Molienda en seco",
      dryMillingName: "Nombre de la molienda en seco",
      dryMillingProdChart: "Gráfico de producción de la molienda en seco",
      view: "Vista",
      date: "Fecha",
      reports: "Informes",
      pests: {
        pestReport: "Informe de Plagas",
        filterByCrops: "Filtrar por Cultivos",
        pestStatistics: "Estadísticas de Plagas",
        regions: "Regiones",
        occurrences: "Ocurrencias",
        pestChart: "Gráfico de Plagas",
        totalArea: "Área Total",
        pestName: "Nombre de la Plaga",
        region: "Región",
        crop: "Cultivos",
        listByLand: "Lista por Terreno",
      },
      regions: {
        regionalReport: "Informe Regional",
        listByFarm: "Listar por Finca",
        listByFarmers: "Listar por Agricultores",
        listByYield: "Listar por Rendimiento",
        regionalStatistics: "Estadísticas Regionales",
        countries: "Países",
        states: "Estados/Provincias",
        city: "Ciudad/Pueblo/Villa",
        farmsIn: "Fincas en",
        regionalChart: "Gráfico Regional",
        farms: "Fincas",
        regionName: "Nombre de la Región",
        farmers: "Agricultores",
        yield: "Rendimiento/Acre",
      },
    },
    // traceability: {
    //     traceability: "trazabilidad",
    //     coffeeTraceabilityMngmnt: "Gestión de trazabilidad del café",
    //     traceabilityPage: "Página de trazabilidad",
    //     labelDesigner: "Diseñador de etiquetas",
    //     additionalInformation: "Información adicional",
    //     info1: "Proporciona información sobre los logotipos adicionales de tu producto. Esta información estará disponible al público en la página de trazabilidad del café.",
    //     addSlogan: "Agregar eslogan",
    //     additionalLogos: "Logotipos adicionales",
    //     title: "Título",
    //     description: "Descripción",
    //     mapLink: "Enlace al mapa",
    //     websiteLink: "Enlace al sitio web",
    //     addMedia: "Agregar medios",
    //     uploadImageVideo: "Subir imagen/video",
    //     origin: "Origen",
    //     info2: "Proporciona información sobre el país de origen de tu producto. Esta información estará disponible al público en la página de trazabilidad del café.",
    //     countryImage: "Imagen del país",
    //     institutionalInfo: "Información institucional",
    //     info3: "Proporciona información sobre tu empresa/cooperativa, cuéntale a los consumidores sobre el trabajo relevante que has estado haciendo. Esta información estará disponible al público en la página de trazabilidad del café.",
    //     cooperativeLogo: "Logotipo de la cooperativa",
    //     traceabilityIntro: "Introducción a la trazabilidad",
    //     info4: "Esta sección le dará al consumidor acceso a toda la historia de producción y procesamiento del café. Describe la importancia de la trazabilidad para tu empresa/cooperativa y para el mundo.",
    //     addLabel: "Agregar etiqueta",
    //     chooseTitle: "Elegir título",
    //     chooseLabelDesign: "Elegir plantilla de diseño de etiqueta",
    //     uploadYourLogo: "Subir tu logotipo",
    //     info5: "Instrucciones: El tamaño de la imagen debe ser de al menos 1000 x 1000 píxeles cuadrados. Puedes elegir un PNG transparente para que se sincronice con los colores de fondo.",
    //     chooseTemplateColors: "Elegir colores de la plantilla",
    //     backgroundColor: "Color de fondo",
    //     foregroundColor: "Color principal",
    //     labelStatus: "Estado de la etiqueta",
    //     inactive: "Inactivo",
    //     download: "Descargar",
    //     enterLabelTitle: "Introduce el título de la etiqueta",
    //   },
    cacaoTraceability: {
      traceability: "trazabilidad",
      cacaoTraceabilityMngmnt: "Gestión de trazabilidad del cacao",
      traceabilityPage: "Página de trazabilidad",
      labelDesigner: "Diseñador de etiquetas",
      additionalInformation: "Información adicional",
      info1:
        "Proporciona información sobre los logotipos adicionales de tu producto. Esta información estará disponible al público en la página de trazabilidad del cacao.",
      addSlogan: "Agregar eslogan",
      additionalLogos: "Logotipos adicionales",
      title: "Título",
      description: "Descripción",
      mapLink: "Enlace al mapa",
      websiteLink: "Enlace al sitio web",
      addMedia: "Agregar medios",
      uploadImageVideo: "Subir imagen/video",
      origin: "Origen",
      info2:
        "Proporciona información sobre el país de origen de tu producto. Esta información estará disponible al público en la página de trazabilidad del cacao.",
      countryImage: "Imagen del país",
      institutionalInfo: "Información institucional",
      info3:
        "Proporciona información sobre tu empresa/cooperativa, cuéntale a los consumidores sobre el trabajo relevante que has estado haciendo. Esta información estará disponible al público en la página de trazabilidad del cacao.",
      cooperativeLogo: "Logotipo de la cooperativa",
      traceabilityIntro: "Introducción a la trazabilidad",
      info4:
        "Esta sección le dará al consumidor acceso a toda la historia de producción y procesamiento del cacao. Describe la importancia de la trazabilidad para tu empresa/cooperativa y para el mundo.",
      addLabel: "Agregar etiqueta",
      chooseTitle: "Elegir título",
      chooseLabelDesign: "Elegir plantilla de diseño de etiqueta",
      uploadYourLogo: "Subir tu logotipo",
      info5:
        "Instrucciones: El tamaño de la imagen debe ser de al menos 1000 x 1000 píxeles cuadrados. Puedes elegir un PNG transparente para que se sincronice con los colores de fondo.",
      chooseTemplateColors: "Elegir colores de la plantilla",
      backgroundColor: "Color de fondo",
      foregroundColor: "Color principal",
      labelStatus: "Estado de la etiqueta",
      inactive: "Inactivo",
      download: "Descargar",
      enterLabelTitle: "Introduce el título de la etiqueta",
    },
    setting: {
      profileAuthSetting: "Configuración de autenticación de perfil",
      logInOutSetting: "Configuración de inicio de sesión/ cierre de sesión",
      autoLogout: "Cierre automático de sesión",
      unsuccessfulLoginAttempt: "Intentos de inicio de sesión sin éxito",
      unsuccessfulLoginLockPeriod:
        "Periodo de bloqueo de inicio de sesión sin éxito",
      passCriteriaSetup: "Configuraciones de los parámetros de la contraseña",
      passLength: "Longitud de contraseña",
      noUniquePassRequired: "Número de contraseñas únicas requeridas",
      maxPassAge: "Edad máxima de la contraseña",
      acceptableRangeOfChars: "Rango aceptable de caracteres",
      upperCase: "Mayúscula",
      lowerCase: "Minúscula",
      numbers: "números",
      specialChars: "Caracteres especiales",
      uniqueSymbols: "Símbolos únicos",
      loadingData: "Cargando datos...",
      currency: "Moneda",
      codeActivationTime: "Hora de activación del código",
      changeGlobalSetting: "Cambiar configuración global",
      globalSetting: "Configuración global",
      generalSetting: "Configuración general",
      hours: "Horas",
      days: "Días",
      minutes: "Minutos",
      perDay: "Por día",
      perHour: "Por hora",
      customised: "Personalizado",
    },
    coffeeData: {
      windBreaker: "Árbol cortavientos",
      horticultureInfo: "Árbol en la horticultura",
      shadeTree: "Árbol de sombra",
      coffeeVariety: "Variedad de café",
      coffeeSpecies: "Especies de café",
      updateWindBreaker: "Actualizar el tipo de árbol cortavientos",
      addWindBreaker: "Añadir nuevo tipo de árbol rompevientos",
      updateHorticultureInfo:
        "Actualizar la información del tipo de árbol en la horticultura",
      addHorticultureInfo:
        "Añadir nueva información del tipo de árbol en la horticultura",
      updateShadeTree: "Actualizar el tipo de árbol cortavientos",
      addShadeTree: "Add New shadeTree Tree Type",
      updateCoffeeVariety: "Actualizar el tipo de la variedad de café",
      addCoffeeVariety: "Añadir el nuevo tipo de árbol de la variedad de café",
      deleteVarietyTitle: "Eliminar la variedad",
      deleteVarietyMessage: "¿Seguro que desea eliminar esta variedad?",
      updateCoffeeSpecie: "Actualizar la especie de café",
      deleteSpecieTitle: "Eliminar la especie",
      deleteSpecieMessage: "¿Seguro que desea eliminar esta especie?",
      addCoffeeSpecie: "Añadir nueva especie de café",
      variety: "Variedad",
      selectVariety: "Seleccionar la variedad",
      deleteCoffeeRecord: "¿Seguro que desea eliminar el registro?",
      deleteCoffeeData: "Eliminar datos del café",
      topicRequired: "Se requiere el nombre del tema",
      coffeeAddSuccess: "Se ha añadido la especie de café correctamente.",
      treeTypeSuccess: "Se ha añadido el tipo de árbol correctamente.",
      treeTypeUpdateSuccess:
        "Se ha actualizado el tipo de árbol correctamente.",
      coffeeVarietySuccess: "Se ha añadido la variedad de café correctamente.",
      coffeeSpecieSuccess:
        "Se ha actualizado la especie de café correctamente.",
      nameRequired: "Se requiere el nombre",
      notFound: "No se ha encontrado los datos del admin café",
    },
    cacaoData: {
      cacao: "Cacao",
      cacaoOverview: "Resumen de Cacao",
      cacaoVariety: "Variedad de Cacao",
      cacaoSpecies: "Especie de Cacao",
      deleteCacaoData: "Eliminar Datos de Cacao",
    },
    plantation: {
      farmerName: "Nombre del granjero",
      phoneNumber: "Número de teléfono",
      plantationName: "Nombre de la plantación",
      farm: "Finca",
      location: "ubicación",
      updatePlantationStatus: "Actualizar situación de la plantación",
      update: "Actualizar",
    },
    activationKey: {
      enterActivationKey: "Please enter activation key to register a new user",
      activationKeyRequired: "Clave de activación requerida",
      activationKeyLimit: "Minimum 15 characters",
      countryRequired: "Country Code is required",
      activationKey: "Teclas de activación",
      appointSalesManager: "Designar gerente de ventas",
      appointManager: "DESIGNAR GERENTE",
      salesManAppSuccess: "GERENTE DE VENTAS DESIGNADO CORRECTAMENTE",
      uploadData: "UPLOAD ASSIGNEDESIGNAR GERENTED DATA CSV",
      uploadUserData: "Cargue el archivo de datos del usuario",
      downloadCsv:
        "(Descargar la muestra archivo .csv para seguir la estructura)",
      downloadSample: "Descargar archivo muestra",
      dragDrop: "Arrastrar y soltar o navegar en su archivo ",
      browse: "explorar",
      yourFile: "su archivo",
      incorectFileType: "Tipo incorrecto de archivo",
      somethingWentWrong: "Algo salió mal. Inténtalo de nuevo más tarde. ",
      fileUploadedSuccess: "Se ha cargado el archivo correctamente",
      countRecords: "Contar registros",
      sendNow: "ENVIAR AHORA",
      fileName: "Nombre del archivo",
      assignActKey: "Designar teclas de activación",
      actKeyAssSucc: "Se ha asignado las teclas de activación correctamente",
      viewActKey: "VISUALIZAR TECLAS DE ACTIVACIÓN",
      actKeyQuota: "Cuota de teclas de activación",
      genActKey: "Teclas de activación generadas",
      remActKey: "Teclas de activación restantes",
      penUsed: "Teclas pendientes y utilizadas",
      activationKeyAss: "Teclas de activación asignadas",
      activationKeyUnass: "Teclas de activación no asignadas",
      keysAct: "Teclas activadas",
      uploadedFiles: "Archivos cargados",
      generateActKey: "GENERAR TECLAS DE ACTIVACIÓN",
      showData: "Mostrar datos",
      noDataFound: "No se ha encontrado ninguna fecha",
      pleaseGenKey:
        'Genere las teclas de activación utilizando "Generar las teclas de activación"',
      noActKey: "No se ha generado ninguna tecla de activación",
      buttonAbv: "botón de arriba",
      numberOfActKey: "Número de teclas de activación",
      membershipRole: "Función de membresía",
      membershipPlan: "Planes de Membresía",
      comments: "Comentarios",
      genKeys: "GENERAR TECLAS",
      keysNum: "Número de teclas",
      phoneNumber: "Número de teléfono",
      keysStatus: "Situación de las teclas",
      ActivationKeysList: "Lista de teclas de activación",
      back: "VOLVER",
      usingActKeys:
        'Genere las teclas de activación utilizando "Generar las teclas de activación""',
      pleaseGenActKeyss: "Genere las teclas de activación",
      clearAllFilters: "ELIMINAR TODOS LOS FILTROS",
      salesManager: "Gerente de ventas",
      clearAll: "ELIMINAR TODO",
      generatedBy: "Generado por",
      numberOfKeys: "Número de teclas",
      action: "Acción",
      viewAllUplFiles: "Visualizar todos los archivos cargados",
      bulkUploadUsers: "Cargar mayor parte de los usuarios",
      noActivationKeyFound: "No se encontrado teclas de activación",
      pleaseCreateAdminRole: "Cree la función admin utilizando el",
      btnCreateAdmin: 'botón "Crear función admin" de arriba',
      donwloadAsCsv: "Descargar como CSV",
      donwloadAsPdf: "Descargar como PDF",
      assignSalesManager: "Designar gerente de ventas",
      shareViaEmail: "Compartir vía correo electrónico",
      sendEmail: "ENVIAR CORREO ELECTRÓNICO",
      emailSend: "SE HA ENVIADO EL CORREO ELECTRÓNICO CORRECTAMENTE",
      donwload: "Descargar",
      deleteFile: "Eliminar archivo",
      invalidFileData:
        "Los datos de la clave de activación en el archivo no son válidos",
    },
    traceability: {
      traceability: "trazabilidad",
      coffeeTraceabilityMngmnt: "Gestión de Trazabilidad del Café",
      traceabilityPage: "Página de Trazabilidad",
      labelDesigner: "Diseñador de Etiquetas",
      additionalInformation: "Información Adicional",
      info1:
        "Proporcione información sobre los logotipos adicionales de su producto. Esta información estará disponible para el público en la página de trazabilidad del café.",
      addSlogan: "Agregar Eslogan",
      additionalLogos: "Logotipos Adicionales",
      title: "Título",
      description: "Descripción",
      mapLink: "Enlace del Mapa",
      websiteLink: "Enlace del Sitio Web",
      addMedia: "Agregar Multimedia",
      uploadImageVideo: "Subir Imagen/Video",
      uploadImage: "Subir Imagen",
      origin: "Origen",
      info2:
        "Proporcione información sobre el país de origen de su producto. Esta información estará disponible para el público en la página de trazabilidad del café.",
      countryImage: "Imagen del País",
      institutionalInfo: "Información Institucional",
      info3:
        "Proporcione información sobre su empresa/cooperativa, cuente a los consumidores sobre el trabajo relevante que ha estado haciendo. Esta información estará disponible para el público en la página de trazabilidad del café.",
      cooperativeLogo: "Logotipo de la Cooperativa",
      traceabilityIntro: "Introducción a la Trazabilidad",
      info4:
        "Esta sección permitirá al consumidor acceder a toda la historia de producción y procesamiento del café. Describa la importancia de la trazabilidad para su empresa/cooperativa y para el mundo.",
      addLabel: "Agregar Etiqueta",
      chooseTitle: "Elegir Título",
      chooseLabelDesign: "Elegir Plantilla de Diseño de Etiqueta",
      uploadYourLogo: "Cargar su Logotipo",
      info5:
        "Instrucciones: El tamaño de la imagen debe ser al menos 1000 x 1000 píxeles cuadrados. Puede elegir PNG transparente para sincronizar con los colores de fondo.",
      chooseTemplateColors: "Elegir colores de la plantilla",
      backgroundColor: "Color de Fondo",
      foregroundColor: "Color de Primer Plano",
      labelStatus: "Estado de la Etiqueta",
      inactive: "Inactivo",
      download: "Descargar",
    },
    memberDataSection: {
      import: "Importar",
      buyingStation: "Estación de Compra",
      continue: "Continuar",
      farmerId: "ID del Agricultor",
      farmerName: "Nombre del Agricultor",
      farmerAddress: "Dirección del Agricultor",
      quality: "Calidad",
      quantity: "Cantidad",
      importAll: "Importar Todo",
      importSelected: "Importar Seleccionado",
      fileLoaded: "Archivo cargado exitosamente",
      incorrectHeaders: "Encabezados incorrectos",
      processingBatch: "Procesando Lote",
      purchaseOrder: "Orden de Compra",
      startDate: "Fecha de Inicio",
      endDate: "Fecha de Fin",
      purchasingOrder: "Orden de Compra",
      totalCoffeeCherry: "Total de Cerezas de Café",
      airHumidity: "Humedad del Aire",
      density: "Densidad",
      temperature: "Temperatura",
      beanMoistureContent: "Contenido de Humedad del Grano",
      processType: "Tipo de Proceso",
      batchRating: "Seleccionar Calificación del Lote",
      purchaseDate: "Fecha de Compra",
      selectFarmer: "Seleccionar Agricultor",
      selectFarm: "Seleccionar Finca",
      selectPlantation: "Seleccionar Plantación",
      coffeeVariety: "Variedad de Café",
      coffeeSpecies: "Especie de Café",
      coffeeCherryQuantity: "Cantidad de Cerezas de Café",
      coffeeCherryQuality: "Calidad de Cerezas de Café",
      coffeeType: "Tipo de Café",
      pricePerKg: "Precio por Kg",
      processingDone: "Procesamiento Completado",
      processedCoffeeOut: "Café Procesado Entregado",
      farmer: "Agricultor",
      farm: "Finca",
      plantation: "Plantación",
      farmers: "Agricultores",
      farmLimitUsed: "Límite de Finca Utilizado",
      phoneNumber: "Número de Teléfono",
      farmSize: "Tamaño de la Finca",
      farmLocation: "Finca/Ubicación",
      date: "Fecha",
      status: "Estado",
      noFarmers: "No se encontraron Agricultores",
      approveReject: "Aprobar/Rechazar",
      farms: "Fincas",
      crops: "Cultivos",
      equipment: "Equipamiento",
      noFarms: "No se encontraron Fincas",
      views: "Vista",
      selectStatus: "Seleccionar Estado",
      approved: "Aprobado",
      rejected: "Rechazado",
      reject: "Rechazar",
      approve: "Aprobar",
      cancel: "Cancelar",
      add: "Agregar",
      describeYourReason: "Describe tu razón aquí",
      userInformation: "Información del Usuario",
      userFarmRequest: "Solicitud de Finca del Usuario",
      userFarmInformation: "Información de Finca(s) del Usuario",
      activity: "Actividad",
      activityType: "Tipo de Actividad",
      farmZone: "Zona de Finca",
      farmerView: "Vista del Agricultor",
      cropType: "Tipo de Cultivo",
      cropVariety: "Variedad de Cultivo",
      area: "Área",
      cost: "Costo",
      geofence: "Geocerca",
      map_views: "Vista de Mapa",
      viewAllFarms: "Ver Todas las Fincas",
      farmersDetails: "Detalles del Agricultor",
      download: "Descargar",
      pOrder: {
        addNew: "Agregar Nuevo",
        viewAll: "Ver Todo",
        selectDate: "Seleccionar fecha",
        makeSelection: "Hacer una selección",
        coffeeType: "Tipo de café",
        enterPrice: "Ingresar Precio",
        reqPurchaseDate: "La fecha de compra es obligatoria",
        reqFarmer: "El agricultor es obligatorio",
        reqCoffeeQnty: "La Cantidad de Cerezas de Café es obligatoria",
        reqPrice: "El Precio Por Kg es obligatorio",
        grandTotal: "TOTAL GENERAL",
        selectDateRange: "Seleccionar Rango de Fechas",
        import: "Importar",
        purchaseId: "ID de Compra",
        purchaseDate: "Fecha de Compra",
        farmerName: "Nombre del Agricultor",
        quality: "Calidad",
        quantity: "Cantidad",
        pricePerKg: "Precio por Kg",
        selectBuyingStation: "Seleccionar estación de compra",
        searchUser: "Buscar Usuarios",
      },
    },
    cropsReport: "Informe de Cultivos",
    today: "Hoy",
    week: "Semana",
    month: "Mes",
    year: "Año",
    all: "Todo",
    cropsStatistics: "Estadísticas de Cultivos",
    crops: "Cultivos",
    acres: "Acres",
    totalPlantedArea: "Área Total Plantada",
    farmersChart: "Gráfico de Agricultores",
    farmsChart: "Gráfico de fincas",
    cropsName: "Nombre de los Cultivos",
    farmers: "Agricultores",
    farms: "Fincas",
    planted: "Plantado",
    plantedArea: "Área Plantada",
    harvested: "Cosechado",
    yieldAcre: "Rendimiento por Acre",
    listByYield: "Listar por Rendimiento",
    listByPlantedArea: "Listar por Área Plantada",
    equipmentReport: "Informe de Equipos",
    equipmentChart: "Gráfico de Equipos",
    selectFarmer: "Seleccionar Agricultor",
    selectFarmers: "Seleccionar Agricultores",
    equipmentName: "Nombre del Equipo",
    region: "Región",
    counts: "Conteos",
    large: "Grande",
    medium: "Mediano",
    small: "Pequeño",
    listByFarmer: "Listar por Agricultor",
    rowsPerPage: "Filas por Página",
    farmersReport: "Informe de Agricultores",
    farmersStatistics: "Estadísticas de Agricultores",
    averageFarmerLand: "Promedio de Tierra por Agricultor",
    largeFarmers: "Agricultores Grandes",
    mediumFarmers: "Agricultores Medianos",
    smallFarmers: "Agricultores Pequeños",
    listByLand: "Listar por Terreno",
    listByFarm: "Listar por Finca",
    AvgLandAcre: "Promedio de Tierra por Acre",
    listbyCrop: "Listar por Cultivo",
    listbyZone: "Listar por Zona",
    farmName: "Nombre de la Finca",
    zones: "Zonas",
    area: "Área",
    goalsAchievedReport: "Informe de Metas Logradas",
    listByCrops: "Listar por Cultivos",
    goalsAchievedChart: "Gráfico de Metas Logradas",
    goalsAchieved: "Metas Logradas",
    goalsFailed: "Metas No Logradas",
    successRate: "Tasa de Éxito",
    achieved: "Logrado",
    equipment: "Equipos",
    pests: "Plagas",
    regions: "Regiones",
    filterByCrops: "Filtrar por Cultivos",
    searchCrops: "Buscar Cultivos",
    batchCode: "Código de Lote",
    batchRating: "Calificación de Lote",
    MakeASelection: "Hacer una Selección",
    typeTotalCoffeeQuantity: "Ingrese la Cantidad Total de Café",
    typeHumidity: "Ingrese la Humedad",
    valueInPercent: "Valor en Porcentaje",
    purchaseOrderRequired: "Se Requiere Orden de Compra",
    totalCoffeeCherryRequired: "Se Requiere Cantidad Total de Cereza de Café",
    processTypeRequired: "Se Requiere Tipo de Proceso",
    stationInfo: "Información de la Estación",
    purchaseOrders: "Órdenes de Compra",
    processingBatch: "Lote de Procesamiento",
    processedCoffeeOutRequired: "Se Requiere Café Procesado",
    lotNo: "Número de Lote",
    addNewS: "Agregar Nuevo",
    viewAll: "Ver Todo",
    parchmentOut: "Pergamino Salido",
    processingDone: "Procesamiento Completado",
    farmerLotID: "ID del Agricultor y Lote",
    weight: "Peso",
    plantationSettings: "Configuración de Plantación",
    PlantationsEachFarmerCanCreate:
      "Número de Plantaciones que Cada Agricultor Puede Crear",
    manageAdditionalPlantationRequests:
      "Gestionar Solicitudes de Plantación Adicionales",
    autoApprove: "Aprobación Automática",
    adminApprovalRequired: "Se Requiere Aprobación del Administrador",
    close: "Cerrar",
    new_user: "Nuevo Usuario",
    KGAcre: "KG/Acre",
    pending: "Pendiente",

    //dashboard report
    "Farmer Name": "Nombre del Agricultor",
    "Goals Achieved": "Metas Logradas",
    "Goals Failed": "Metas Fallidas",
    "Success Rate": "Tasa de Éxito",

    "Equipment Name": "Nombre del Equipo",
    Region: "Región",
    Farmer: "Agricultor",
    Counts: "Recuentos",

    "Pest Name": "Nombre de la Plaga",
    "Total Area": "Área Total",
    Crop: "Cultivo",

    "Crop Name": "Nombre del Cultivo",
    Farmers: "Agricultores",
    Farms: "Fincas",
    Planted: "Sembrado",
    "Planted Area": "Área Sembrada",
    Harvested: "Cosechado",
    "Yield/acre": "Rendimiento por Acre",
    "Region Name": "Nombre de la Región",
    "Avg. Land/Acre": "Promedio de Tierra por Acre",
    Crops: "Cultivos",
    "Yield/area": "Rendimiento/área",
    "Avg. land/Acre": "Promedio de tierra/Acre",
    "Farm Name": "Nombre de la Finca",
    Zones: "Zonas",
    Area: "Área",

    "Goals Achieved Report": "Informe de Metas Logradas",
    "Farms Report": "Informe de Fincas",
    "Pest Report": "Informe de Plagas",
    "Equipment Report": "Informe de Equipos",
    "Crops Report": "Informe de Cultivos",
    "Farmers Report": "Informe de Agricultores",
    "Regional Report": "Informe Regional",

    importAll: "Importar Todo",
    importSelected: "Importar Seleccionado",
    fileLoaded: "Archivo cargado exitosamente",
    incorrectHeaders: "Encabezados incorrectos",
    purchaseOrder: "Orden de Compra",
    startDate: "Fecha de Inicio",
    endDate: "Fecha de Fin",
    purchasingOrder: "Orden de Compra",
    totalCoffeeCherry: "Total de Cerezas de Café",
    airHumidity: "Humedad del Aire",
    density: "Densidad",
    temperature: "Temperatura",
    beanMoistureContent: "Contenido de Humedad del Grano",
    processType: "Tipo de Proceso",
    purchaseDate: "Fecha de Compra",
    selectFarm: "Seleccionar Finca",
    selectPlantation: "Seleccionar Plantación",
    coffeeVariety: "Variedad de Café",
    coffeeSpecies: "Especie de Café",
    coffeeCherryQuantity: "Cantidad de Cerezas de Café",
    coffeeCherryQuality: "Calidad de Cerezas de Café",
    coffeeType: "Tipo de Café",
    pricePerKg: "Precio por Kg",
    processedCoffeeOut: "Café Procesado Entregado",
    farmer: "Agricultor",
    farm: "Finca",
    farmLimitUsed: "Límite de Finca Utilizado",
    phoneNumber: "Número de Teléfono",
    farmSize: "Tamaño de la Finca",
    farmLocation: "Finca/Ubicación",
    status: "Estado",
    noFarmers: "No se encontraron Agricultores",
    approveReject: "Aprobar/Rechazar",
    noFarms: "No se encontraron Fincas",
    views: "Vista",
    selectStatus: "Seleccionar Estado",
    approved: "Aprobado",
    rejected: "Rechazado",
    reject: "Rechazar",
    approve: "Aprobar",
    cancel: "Cancelar",
    add: "Agregar",
    describeYourReason: "Describe tu razón aquí",
    userInformation: "Información del Usuario",
    userFarmRequest: "Solicitud de Finca del Usuario",
    userFarmInformation: "Información de Finca(s) del Usuario",
    activity: "Actividad",
    activityType: "Tipo de Actividad",
    farmZone: "Zona de Finca",
    farmerView: "Vista del Agricultor",
    cropType: "Tipo de Cultivo",
    cropVariety: "Variedad de Cultivo",
    cost: "Costo",
    geofence: "Geocerca",
    map_views: "Vista de Mapa",
    viewAllFarms: "Ver Todas las Fincas",
    farmersDetails: "Detalles del Agricultor",
    download: "Descargar",
    pOrder: {
      addNew: "Agregar Nuevo",
      viewAll: "Ver Todo",
      selectDate: "Seleccionar fecha",
      makeSelection: "Hacer una selección",
      coffeeType: "Tipo de café",
      enterPrice: "Ingresar Precio",
      reqPurchaseDate: "La fecha de compra es obligatoria",
      reqFarmer: "El agricultor es obligatorio",
      reqCoffeeQnty: "La Cantidad de Cerezas de Café es obligatoria",
      reqPrice: "El Precio Por Kg es obligatorio",
      grandTotal: "TOTAL GENERAL",
      selectDateRange: "Seleccionar Rango de Fechas",
      import: "Importar",
      purchaseId: "ID de Compra",
      purchaseDate: "Fecha de Compra",
      farmerName: "Nombre del Agricultor",
      quality: "Calidad",
      quantity: "Cantidad",
      pricePerKg: "Precio por Kg",
      selectBuyingStation: "Seleccionar estación de compra",
      searchUser: "Buscar Usuarios",
    },

    farmActivity: "Actividad Agrícola",
    showOnMap: "Mostrar en el Mapa",
    farmInformation: "Información de la Finca",
    dateOfEntry: "Fecha de Ingreso",
    farmID: "ID de la Finca",
    ownershipType: "Tipo de Propiedad",
    locationAddress: "Dirección de Ubicación",
    goalType: "Tipo de Objetivo",
    totalSize: "Tamaño Total",
    farmActivities: "Actividades Agrícolas",
    farmDetails: "Detalles de la Finca",
    totalFarmsRegistered: "Total de Fincas Registradas",
    totalFarmArea: "Área Total de la Finca",
    totalZone: "Total de Zonas",
    zone: "Zona",

    totalCost: "Costo Total",
    selectFarmZone: "Seleccionar Zona/Finca",
    productionType: "Tipo de Producción",
    certifications: "Certificaciones",
    geofences: "Geovallas",
    
    // Buying Station specific translations
    buyingStations: "Estaciones de Compra",
    registerBuyingStation: "Registrar Estación de Compra",
    registerAffiliate: "Registrar Afiliado",
    loadingAffiliate: "Cargando Afiliado...",
    loadingBuyingStation: "Cargando Estación de Compra...",
    searchBuyingStation: "Buscar Estación de Compra",
    searchAffiliate: "Buscar Afiliado",
    nameAndId: "Nombre / ID",
    email: "Correo Electrónico",
    mobileNumber: "Número Móvil",
    role: "Rol",
    actions: "Acciones",
        view: "Ver",
    edit: "Editar",
    activate: "Activar",
    deactivate: "Desactivar",
    society: "Sociedad",
    operator: "Operador",
    supplier: "Proveedor",
    active: "Activo",
    deactivated: "Desactivado",
    activatedSuccessfully: "Estación de compra activada exitosamente",
    deactivatedSuccessfully: "Estación de compra desactivada exitosamente",
    deletedSuccessfully: "Estación de compra eliminada exitosamente",
    duplicatedSuccessfully: "Estación de compra duplicada exitosamente",
    confirmDialog: {
      delete: {
        title: "Eliminar Estación de Compra",
        message: "¿Estás seguro de que quieres eliminar esta estación de compra?",
        confirmBtn: "Eliminar",
      }
    },
    registerNewAffiliate: "Registrar Nuevo Afiliado",
    selectHowYouWantToProceed: "Selecciona cómo quieres proceder",
    single: "Single",
    multiple: "Multiple",
    createNewAffiliate: "Crear Nuevo Afiliado",
    affiliateName: "Nombre del Afiliado",
    affiliateNumber: "Número de Afiliado",
    firstName: "Nombre",
    lastName: "Apellido",
    primaryEmailAddress: "Correo Electrónico Principal",
    submit: "Enviar",
  },
}